function PlantConfigSlotRow({
  fieldName,
  label,
  textValue,
  checked,
  numberValue,
  error,
  onChange,
  onCheckbox,
  onColumnNo,
  showAllColumns,
}) {
  const min = checked && showAllColumns === 'true' ? '1' : '0';

  return (
    <>
      <div className="plant-config-bin-row">
        <label htmlFor={fieldName} className="text-right">{label}</label>
        <input
          type="text"
          id={fieldName}
          maxLength="10"
          name={fieldName}
          onChange={onChange}
          value={textValue || ''}
          className="form-control"
          placeholder={`Please fill the ${label.toLowerCase()} field *`}
        />
        <input
          type="checkbox"
          className="is_store"
          name={`is_${fieldName}`}
          checked={!!checked}
          onChange={onCheckbox}
        />
        <input
          type="number"
          min={min}
          max="20"
          id={`${fieldName}_no`}
          name={`${fieldName}_no`}
          onChange={onColumnNo}
          value={numberValue || 0}
          className="form-control"
        />
      </div>
      {error ? (
        <strong className="plant-config-bin-error text-danger">{error}</strong>
      ) : null}
    </>
  );
}

export default PlantConfigSlotRow;
